function keywordMarquee() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const mobileMediaQuery = window.matchMedia('(max-width: 740px)');
  const resumeDelay = 3000;
  const startDelay = 500;
  const dragThreshold = 5;

  document.querySelectorAll('.c-index-sidebar__keyword').forEach((container) => {
    const scrollDuration = container.dataset.scrollDuration;
    const track = container.querySelector('.c-index-sidebar__keyword--track');
    if (!track) return;

    const lists = track.querySelectorAll('.c-index-sidebar__keyword--list');
    if (lists.length < 2) return;

    let loopWidth = 0;
    let offset = 0;
    let isPaused = false;
    let isDragging = false;
    let canAutoScroll = false;
    let resumeTimer = null;
    let animationFrameId = null;
    let lastTimestamp = null;
    let dragStartX = 0;
    let dragStartOffset = 0;
    let activePointerId = null;

    const measureLoopWidth = () => {
      const trackStyle = getComputedStyle(track);
      const gap = parseFloat(trackStyle.columnGap || trackStyle.gap) || 0;
      loopWidth = lists[0].getBoundingClientRect().width + gap;
    };

    const normalizeOffset = () => {
      if (loopWidth <= 0) return;

      while (offset >= loopWidth) {
        offset -= loopWidth;
      }

      while (offset < 0) {
        offset += loopWidth;
      }
    };

    const applyOffset = () => {
      normalizeOffset();
      track.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
    };

    const pause = () => {
      isPaused = true;
      lastTimestamp = null;

      if (resumeTimer) {
        clearTimeout(resumeTimer);
        resumeTimer = null;
      }
    };

    const scheduleResume = () => {
      if (resumeTimer) clearTimeout(resumeTimer);

      resumeTimer = setTimeout(() => {
        isPaused = false;
        lastTimestamp = null;
      }, resumeDelay);
    };

    const tick = (timestamp) => {
      if (!mobileMediaQuery.matches) return;

      if (
        canAutoScroll &&
        !isPaused &&
        !isDragging &&
        loopWidth > container.clientWidth
      ) {
        if (lastTimestamp !== null) {
          const delta = timestamp - lastTimestamp;
          offset += (loopWidth / scrollDuration) * delta;
          applyOffset();
        }

        lastTimestamp = timestamp;
      } else if (isPaused || isDragging) {
        lastTimestamp = null;
      }

      animationFrameId = requestAnimationFrame(tick);
    };

    const start = () => {
      if (!mobileMediaQuery.matches) return;

      measureLoopWidth();

      if (loopWidth <= container.clientWidth) return;

      if (animationFrameId) cancelAnimationFrame(animationFrameId);
      animationFrameId = requestAnimationFrame(tick);
    };

    const stop = () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
      }

      lastTimestamp = null;
      offset = 0;
      track.style.transform = '';
    };

    container.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      activePointerId = event.pointerId;
      isDragging = false;
      dragStartX = event.clientX;
      dragStartOffset = offset;
      pause();
    });

    container.addEventListener(
      'pointermove',
      (event) => {
        if (event.pointerId !== activePointerId) return;

        const deltaX = event.clientX - dragStartX;

        if (!isDragging && Math.abs(deltaX) < dragThreshold) return;

        if (!isDragging) {
          isDragging = true;
          container.setPointerCapture(event.pointerId);
        }

        event.preventDefault();
        offset = dragStartOffset - deltaX;
        applyOffset();
      },
      { passive: false }
    );

    const endPointerInteraction = (event) => {
      if (event.pointerId !== activePointerId) return;

      if (isDragging) {
        if (container.hasPointerCapture(event.pointerId)) {
          container.releasePointerCapture(event.pointerId);
        }

        event.preventDefault();
      }

      isDragging = false;
      activePointerId = null;
      scheduleResume();
    };

    container.addEventListener('pointerup', endPointerInteraction);
    container.addEventListener('pointercancel', endPointerInteraction);

    window.addEventListener('resize', () => {
      measureLoopWidth();
      applyOffset();
    });

    mobileMediaQuery.addEventListener('change', (event) => {
      if (event.matches) {
        start();
      } else {
        stop();
      }
    });

    setTimeout(() => {
      canAutoScroll = true;
    }, startDelay);

    start();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  keywordMarquee();
});
